import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ImgCover from 'assets/cover.jpg';
import { useI18n } from 'locales';

function NotFoundPage() {
  const [duration, setDuration] = useState(3);
  const navigate = useNavigate();
  const t = useI18n();

  useEffect(() => {
    const interval = setInterval(() => setDuration(duration - 1), 1000);

    if (duration === 0) {
      navigate('/dashboard');
    }

    return () => clearInterval(interval);
  }, [duration, navigate]);

  return (
    <Stack
      component='main'
      justifyContent='center'
      alignItems='center'
      sx={{ width: '100%', height: '100vh' }}
    >
      <Box sx={{ zIndex: -1, width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}>
        <img
          src={ImgCover}
          alt='background'
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(8px)',
            opacity: 0.8,
            transform: 'scale(1.1)'
          }}
        />
      </Box>

      <Paper elevation={5} sx={{ p: 5 }}>
        <Stack direction='column' gap={2} alignItems='center'>
          <Typography variant='h1' sx={{ fontWeight: 500 }}>
            {t('Page not found')}
          </Typography>

          <Typography variant='subtitle1' color='grey.600'>
            {t('Redirecting to dashboard in ')}... {duration}s
          </Typography>
        </Stack>
      </Paper>
    </Stack>
  );
}

export default NotFoundPage;
